/* eslint-disable array-callback-return */
import { useNavigate } from "react-router-dom";
import { RightIcon } from "../../components/icons";
import { toDateType, toTwoDecimals } from "../../plugins";

const OpenInvoiceItem = ({ item }) => {
    const navigate = useNavigate();

    return (
        <div
            className='table-details'
            onClick={() => navigate("/profile/open-invoices/" + item._id)}
        >
            <span className='table-cell row-order-nbr'>
                {item.OrderNbr?.value || '-'}
            </span>
            <span className='table-cell row-due-date'>
                {item.DueDate?.value ? toDateType(item.DueDate.value) : '-'}
            </span>
            <span 
                className='table-cell row-status d-sm-block d-none'
                data-status={item.Status?.value?.toLowerCase()}
            >
                {item.Status?.value ? item.Status.value : '-'}
            </span>
            <span className='table-cell row-amount'>
                {item.Amount?.value ? '$' + toTwoDecimals(Number(item.Amount.value)) : '-'}
            </span>
            <span className='table-cell row-amount'>
                {item.Balance?.value ? '$' + toTwoDecimals(Number(item.Balance.value)) : '-'}
            </span>
            <span className='table-cell row-action'>
                <RightIcon width='24' height='24' />
            </span>
        </div>
    );
};

export default OpenInvoiceItem;
